// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"JoinPageModal_iconWrapper__wlkTY","modal":"JoinPageModal_modal__QACb1","body":"JoinPageModal_body__ZmpAF","footer":"JoinPageModal_footer__ZYl6z"};